module.exports = __webpack_public_path__ + "media/images/emblems/GW-SG-Neckertal-da03be3d5b71276fcec9065414d8b542.png";